import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const USHV_ORION_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.ADMIN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Return to Work Letter Request, documents to be signed by non provider staff",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN,
    group: "ushv-orion",
  },
  [Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Certificate of Medical Necessity",
    documentLabel: "{{dateReceived}} Certificate of Medical Necessity",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_CERTIFICATE_OF_MEDICAL_NECESSITY,
    group: "ushv-orion",
  },
  [Classification.ADMIN_DEATH_CERTIFICATES]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Valencia,Lus",
    displayName: "Death/Expired Report",
    documentLabel: "{{dateReceived}} Death Report",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_DEATH_CERTIFICATES,
    group: "ushv-orion",
  },
  [Classification.ADMIN_DISABILITY_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Disability Paperwork, FMLA Paperwork",
    documentLabel: "{{dateReceived}} Disability/FMLA Forms",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_DISABILITY_FORMS,
    group: "ushv-orion",
  },
  [Classification.ADMIN_PATIENT_QUESTIONNAIRE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jaramillo,Denise",
    displayName: "Patient Questionnaires",
    documentLabel: "{{dateReceived}} Patient Questionnaire",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_PATIENT_QUESTIONNAIRE,
    group: "ushv-orion",
  },
  [Classification.ADMIN_TRANSITION_CARE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Martinez,Amanda",
    displayName: "Transition of Care (TDC)",
    documentLabel: "{{dateReceived}} OV Referral Notes",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_TRANSITION_CARE,
    group: "ushv-orion",
  },
  [Classification.CLEARANCE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Cardiac Clearance Request/Anesthesia/Pre-anesthesia Request",
    documentLabel: "{{dateReceived}} Cardiac Clearance Request",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CLEARANCE_REQUEST,
    group: "ushv-orion",
  },
  [Classification.DME_ORDER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "DME Order",
    documentLabel: "{{dateReceived}} DME Order",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.DME_ORDER,
    group: "ushv-orion",
  },
  [Classification.FINANCIAL_BILLING_RECORDS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Billing Documents",
    documentLabel: "",
    folder: null,
    folderMapping: null,
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "External Routing WF",
    classification: Classification.FINANCIAL_BILLING_RECORDS,
    group: "ushv-orion",
  },
  [Classification.IDENTIFICATION_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jaramillo,Denise",
    displayName: "ID/DL/Passport",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IDENTIFICATION_CARD,
    group: "ushv-orion",
  },
  [Classification.IMAGING_RESULTS_CARDIAC_LEG_IMAGING]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Leg Images",
    documentLabel: "{{dateOfEvent}} Cardiac Leg Images",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_CARDIAC_LEG_IMAGING,
    group: "ushv-orion",
  },
  [Classification.IMAGING_RESULTS_COLONOSCOPY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Colonoscopy Report",
    documentLabel: "{{dateOfEvent}} Colonoscopy",
    folder: "Non Cardiovascular",
    folderMapping: "Non Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_COLONOSCOPY,
    group: "ushv-orion",
  },
  [Classification.IMAGING_RESULTS_CT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "CT Scans",
    documentLabel: "{{dateOfEvent}} CT",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_CT,
    group: "ushv-orion",
  },
  [Classification.IMAGING_RESULTS_ECHO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Echocardiogram Reports",
    documentLabel: "{{dateOfEvent}} Echo",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ECHO,
    group: "ushv-orion",
  },
  [Classification.IMAGING_RESULTS_EKG]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "ECG/EKG",
    documentLabel: "{{dateOfEvent}} EKG",
    folder: "EKG",
    folderMapping: "EKG",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_EKG,
    group: "ushv-orion",
  },
  [Classification.IMAGING_RESULTS_ENDOSCOPY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Endoscopy Report",
    documentLabel: "{{dateOfEvent}} Endoscopy",
    folder: "Non Cardiovascular",
    folderMapping: "Non Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ENDOSCOPY,
    group: "ushv-orion",
  },
  [Classification.IMAGING_RESULTS_HOLTER_MONITOR]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Holter Event Monitor Reports",
    documentLabel: "{{dateOfEvent}} Monitor Report",
    folder: "Monitors",
    folderMapping: "Monitors",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_HOLTER_MONITOR,
    group: "ushv-orion",
  },
  [Classification.IMAGING_RESULTS_MAMMOGRAM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Mammogram Report",
    documentLabel: "{{dateOfEvent}} Mammogram",
    folder: "Non Cardiovascular",
    folderMapping: "Non Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MAMMOGRAM,
    group: "ushv-orion",
  },
  [Classification.IMAGING_RESULTS_MONITOR_NOTIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "ACS No Transmission Notification",
    documentLabel: "{{dateReceived}} Monitor Notification",
    folder: "Monitors",
    folderMapping: "Monitors",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MONITOR_NOTIFICATION,
    group: "ushv-orion",
  },
  [Classification.IMAGING_RESULTS_MRI]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "CMR Report, Radiology Report",
    documentLabel: "{{dateOfEvent}} MRI",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MRI,
    group: "ushv-orion",
  },
  [Classification.IMAGING_RESULTS_NM]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Nuclear Scans",
    documentLabel: "{{dateOfEvent}} Nuclear",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_NM,
    group: "ushv-orion",
  },
  [Classification.IMAGING_RESULTS_PET]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Myocardial Perfusion (PET CT)",
    documentLabel: "{{dateOfEvent}} PET",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_PET,
    group: "ushv-orion",
  },
  [Classification.IMAGING_RESULTS_STRESS_TEST_EXERCISE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Exercise Treadmill Test Report",
    documentLabel: "{{dateOfEvent}} Stress Test",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_STRESS_TEST_EXERCISE,
    group: "ushv-orion",
  },
  [Classification.IMAGING_RESULTS_ULTRASOUND]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Ultrasound Report, Any Type (Abdominal, etc.)",
    documentLabel: "{{dateOfEvent}} Ultrasound",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_ULTRASOUND,
    group: "ushv-orion",
  },
  [Classification.IMAGING_RESULTS_X_RAY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "X-Rays",
    documentLabel: "{{dateOfEvent}} XR",
    folder: "Non-Invasive Cardiovascular",
    folderMapping: "Non-Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_X_RAY,
    group: "ushv-orion",
  },
  [Classification.INSURANCE_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jaramillo,Denise",
    displayName: "Insurance Cards",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INSURANCE_CARD,
    group: "ushv-orion",
  },
  [Classification.INTAKE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jaramillo,Denise",
    displayName: "Patient Demographics",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INTAKE,
    group: "ushv-orion",
  },
  [Classification.JUNK]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Ads, Blank Pages",
    documentLabel: "",
    folder: null,
    folderMapping: null,
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Delete",
    classification: Classification.JUNK,
    group: "ushv-orion",
  },
  [Classification.LAB_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Lab Results",
    documentLabel: "{{collectionDate}} Labs",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS,
    group: "ushv-orion",
  },
  [Classification.LAB_RESULTS_BP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "BP Logs",
    documentLabel: "{{collectionDate}} BP Log",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_BP,
    group: "ushv-orion",
  },
  [Classification.LAB_RESULTS_PATHOLOGY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Pathology/Biopsy Reports",
    documentLabel: "{{collectionDate}} Path/Biopsy",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_PATHOLOGY,
    group: "ushv-orion",
  },
  [Classification.LAB_RESULTS_PT_INR]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "PT/INR, Alere Home Monitoring",
    documentLabel: "{{collectionDate}} PT-INR",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_PT_INR,
    group: "ushv-orion",
  },
  [Classification.LAB_RESULTS_QUANTAFLO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "QuantaFlo",
    documentLabel: "{{collectionDate}} Quanta Flo",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_QUANTAFLO,
    group: "ushv-orion",
  },
  [Classification.LEGAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jaramillo,Denise",
    displayName: "POA's (Power of Attorney), Arbitration Forms (Timestamp & Review)",
    documentLabel: "{{dateReceived}} Patient Forms",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LEGAL,
    group: "ushv-orion",
  },
  [Classification.MEDICAL_HISTORY_CHART_FROM_CLINIC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Non-USHV Clinic Notes",
    documentLabel: "{{dateOfEvent}} Clinic Notes",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_CHART_FROM_CLINIC,
    group: "ushv-orion",
  },
  [Classification.MEDICAL_HISTORY_CHART_FROM_HOSPITAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Hospital/Other Dr's Consult/Progress Notes",
    documentLabel: "{{dateOfEvent}} Hospital Notes",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_CHART_FROM_HOSPITAL,
    group: "ushv-orion",
  },
  [Classification.MEDICAL_HISTORY_HOME_HEALTH]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "HomeHealth Service/Physician Order",
    documentLabel: "{{dateOfEvent}} HomeHealth Service/Order",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_HOME_HEALTH,
    group: "ushv-orion",
  },
  [Classification.MEDICAL_HISTORY_MEDICATIONS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Medication List",
    documentLabel: "{{dateReceived}} Medications - Vaccines",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY_MEDICATIONS,
    group: "ushv-orion",
  },
  [Classification.MEDICAL_RECORD_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Valencia,Lus",
    displayName: "Medical Records Release/Request",
    documentLabel: "{{dateReceived}} Medical Records Request",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_RECORD_REQUEST,
    group: "ushv-orion",
  },
  [Classification.NOTIFICATION_HOSPITAL_DISCHARGE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Hospital Discharge Notes/Instructions",
    documentLabel: "{{dateOfEvent}} Hospital Discharge Notification",
    folder: "Hospital Records",
    folderMapping: "Hospital Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.NOTIFICATION_HOSPITAL_DISCHARGE,
    group: "ushv-orion",
  },
  [Classification.ORDER_CARDIAC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Cupid Order Note",
    documentLabel: "{{dateReceived}} Cardiac Order",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_CARDIAC,
    group: "ushv-orion",
  },
  [Classification.ORDER_CLARIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Unsupported CPT for Imaging Orders",
    documentLabel: "{{dateReceived}} CPT Needed",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_CLARIFICATION,
    group: "ushv-orion",
  },
  [Classification.ORDER_IMAGING]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Imaging Orders",
    documentLabel: "{{dateReceived}} Imaging Orders",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_IMAGING,
    group: "ushv-orion",
  },
  [Classification.ORDER_LAB]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Lab Orders",
    documentLabel: "{{dateReceived}} Lab Order",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_LAB,
    group: "ushv-orion",
  },
  [Classification.PHARMACY_RELATED_ALERT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Medication Alerts/Advisories/Therapeutic Alerts",
    documentLabel: "",
    folder: null,
    folderMapping: null,
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Delete",
    classification: Classification.PHARMACY_RELATED_ALERT,
    group: "ushv-orion",
  },
  [Classification.PHARMACY_RELATED_CARE_CONSIDERATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Medication Considerations",
    documentLabel: "{{dateReceived}} Care Consideration",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_CARE_CONSIDERATION,
    group: "ushv-orion",
  },
  [Classification.PHARMACY_RELATED_CLARIFICATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Prescriber Response Form",
    documentLabel: "{{dateReceived}} RX Response Form",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_CLARIFICATION,
    group: "ushv-orion",
  },
  [Classification.PHARMACY_RELATED_REFILL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Refill Authorization Requests",
    documentLabel: "{{dateReceived}} RX Refill Request",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED_REFILL,
    group: "ushv-orion",
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Clear Rx,Team",
    displayName: "Prior Authorization Requests (Prescriptions)",
    documentLabel: "{{dateReceived}} Prior Auth Request",
    folder: "Authorization Forms",
    folderMapping: "Authorization Forms",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST,
    group: "ushv-orion",
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Jaramillo,Denise",
    displayName: "Prior Authorization Approval/Denial (Prescriptions)",
    documentLabel: "{{dateReceived}} Prior Auth",
    folder: "Authorization Forms",
    folderMapping: "Authorization Forms",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE,
    group: "ushv-orion",
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Castillo,Estefania",
    displayName: "Prior Authorization Requests for Procedures",
    documentLabel: "{{dateReceived}} Prior Auth Request",
    folder: "Authorization Forms",
    folderMapping: "Authorization Forms",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST,
    group: "ushv-orion",
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Castillo,Estefania",
    displayName: "Prior Authorization Approval/Denial (Procedures/Imaging)",
    documentLabel: "{{dateReceived}} Prior Auth",
    folder: "Authorization Forms",
    folderMapping: "Authorization Forms",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE,
    group: "ushv-orion",
  },
  [Classification.PRIOR_AUTHORIZATION_REFERRAL_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Camacho,Jessica",
    displayName: "Prior Authorization Approval/Denial (Referrals)",
    documentLabel: "{{dateReceived}} Referral PA {{authorizationStatus}}",
    folder: "Referral Documents",
    folderMapping: "Referral Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_REFERRAL_RESPONSE,
    group: "ushv-orion",
  },
  [Classification.PROCEDURE_CARDIAC]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Cath Diagram, Heart Cath Hospital Notes/Diagram, Angiogram",
    documentLabel: "{{dateOfEvent}} Cardiac Report",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_CARDIAC,
    group: "ushv-orion",
  },
  [Classification.PROCEDURE_CARDIAC_VEIN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Venous Questionnaires",
    documentLabel: "{{dateReceived}} Venous Questionnaire",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_CARDIAC_VEIN,
    group: "ushv-orion",
  },
  [Classification.PROCEDURE_DEVICE_INFO]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Martinez,Amanda",
    displayName: "Implant Registration/Info/Card",
    documentLabel: "{{dateReceived}} Device Info",
    folder: "Monitors",
    folderMapping: "Monitors",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_DEVICE_INFO,
    group: "ushv-orion",
  },
  [Classification.PROCEDURE_DEVICE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Device/Implantables Transfer Request",
    documentLabel: "{{dateReceived}} Device Transfer Request",
    folder: "Monitors",
    folderMapping: "Monitors",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_DEVICE_REQUEST,
    group: "ushv-orion",
  },
  [Classification.PROCEDURE_REHAB]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Cardiac Rehab",
    documentLabel: "{{dateOfEvent}} Cardiac Rehab",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_REHAB,
    group: "ushv-orion",
  },
  [Classification.PROCEDURE_SLEEP]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Palomar,Rosario",
    displayName: "Sleep Study Reports",
    documentLabel: "{{dateOfEvent}} Sleep Report",
    folder: "Non Cardiovascular",
    folderMapping: "Non Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROCEDURE_SLEEP,
    group: "ushv-orion",
  },
  [Classification.PROGRESS_NOTE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Non-USHV Progress Notes",
    documentLabel: "{{dateOfEvent}} Progress Notes",
    folder: "Outside Clinic Records",
    folderMapping: "Outside Clinic Records",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE,
    group: "ushv-orion",
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Inpatient Discharge Summary Report",
    documentLabel: "{{dateOfEvent}} Hospital Discharge Summary",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_DISCHARGE_SUMMARY,
    group: "ushv-orion",
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_RECORDS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "H&P Notes",
    documentLabel: "{{dateOfEvent}} HP Notes",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_RECORDS,
    group: "ushv-orion",
  },
  [Classification.PROGRESS_NOTE_HOSPITAL_SUMMARY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "Summary of Care",
    documentLabel: "{{dateOfEvent}} Hospital Summary of Care",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_HOSPITAL_SUMMARY,
    group: "ushv-orion",
  },
  [Classification.PROGRESS_NOTE_OPERATIVE_REPORT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Provider,staff",
    displayName: "OP Reports",
    documentLabel: "{{dateOfEvent}} Op Report",
    folder: "Invasive Cardiovascular",
    folderMapping: "Invasive Cardiovascular",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_OPERATIVE_REPORT,
    group: "ushv-orion",
  },
  [Classification.REFERRAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Camacho,Jessica",
    displayName: "Patient Referrals",
    documentLabel: "{{dateOfReferral}} Referral Order",
    folder: "Referral Documents",
    folderMapping: "Referral Documents",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL,
    group: "ushv-orion",
  },
  [Classification.REFERRAL_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "Camacho,Jessica",
    displayName: "Referral Responses",
    documentLabel: "{{dateReceived}} Referral Response",
    folder: "Clinic Notes",
    folderMapping: "Clinic Notes",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL_RESPONSE,
    group: "ushv-orion",
  },
} as const;
